export const createNavMetadataFromFormObject = (formObject: any) => {
	return (formObject?.components as any[])
		?.reduce(function(result, component: any) {
		if (!component.key?.startsWith('navigationEventDummy')) {
				result.push({ id: component.id, label: component.title });
			}
			return result;
		}, []);
};